import { arrayBufferToBase64 } from '../utils/utility';
import { URL } from '../constants';


const registerAccount = async account => {
    const response = await fetch(`${URL}/user`, {
            headers: { 'Content-Type': 'application/json'},
            method: 'POST',
            body: JSON.stringify(account)
        });
    const data = await response.json();
    

    if(response.status >= 400) {
        throw new Error(data.errors);
    }
}


const fetchCaptcha = async () => {
    const response = await fetch(`${URL}/auth/captcha`, {
    	credentials: 'include'
    });
    
    const captchaImage = await response.arrayBuffer().then((buffer) => {
        var base64Flag = 'data:image/jpeg;base64,';
        var imageStr = arrayBufferToBase64(buffer);
        return base64Flag + imageStr;
    });
    return [captchaImage];
}

const login = async formData => {
	const response = await fetch(`${URL}/auth/login`, {
    	credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(formData)
    });
    return response;
}

const queryFunction = async formData => {
	const response = await fetch(`${URL}/system/function/findFunctions`, {
    	credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(formData)
    });
    const result = await response.json();
    return result;
}

const queryGroup = async formData => {
	const response = await fetch(`${URL}/system/group/findGroups`, {
    	credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(formData)
    });
	const result = await response.json();
    return result;
}

const queryBidCaseReview = async formData => {
	const response = await fetch(`${URL}/system/group/findGroups`, {
    	credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(formData)
    });
    const result = await response.json();
    return result;
}

export {registerAccount, fetchCaptcha, login, queryGroup, queryFunction, queryBidCaseReview};

